import React, { useEffect, useState, useRef } from "../../__compat__/react/main.entry.mjs.mjs";
import { Icon, Text } from "../index.mjs.mjs";
import { StyledButton, StyledTextWrapper, StyledNotification, StyledContentWrapper, } from "./Notification.styles.mjs.mjs";
const getIcon = (variant, icon) => {
    if (variant === 'success') {
        return React.createElement(Icon, { name: "select-circle", variant: "positive", size: "small" });
    }
    if (variant === 'error') {
        return React.createElement(Icon, { name: "caution", variant: "negative", size: "small" });
    }
    if (icon) {
        return React.createElement(Icon, { name: icon, variant: "primary", size: "small" });
    }
    return;
};
export const Notification = ({ headline, copy, variant, children, icon, closeButton, className, isOpen, id, ariaLabel, ariaLive, }) => {
    const ref = useRef(null);
    const [shouldRender, setShouldRender] = useState(isOpen);
    const headlineId = `${id}-heading`;
    useEffect(() => {
        if (isOpen)
            setShouldRender(true);
    }, [isOpen]);
    const onAnimationEnd = () => !isOpen && setShouldRender(false);
    return (React.createElement(React.Fragment, null, shouldRender && (React.createElement(StyledNotification, { role: "status", "aria-live": ariaLive, "aria-labelledby": headline && headlineId, className: className, onAnimationEnd: onAnimationEnd, isOpen: isOpen, ref: ref, "aria-label": ariaLabel },
        getIcon(variant, icon),
        React.createElement(StyledContentWrapper, null,
            React.createElement(StyledTextWrapper, null,
                headline && (React.createElement(Text, { variant: "copy2", weight: "bold", id: headlineId }, headline)),
                React.createElement(Text, { variant: "copy2" }, copy)),
            children),
        closeButton && (React.createElement(StyledButton, { onClick: closeButton.onClick, "aria-label": closeButton.ariaLabel },
            React.createElement(Icon, { name: "cancel", size: "small" })))))));
};
//# sourceMappingURL=Notification.mjs.mjs.map